import {
    convertUniversalDateTimeToPersianDateTime,
    RaikoCardInfoTypeOne,
    RaikoCardInfoTypeOneItemGenerator,
    RaikoGridOneColumn,
    RaikoGridThreeColumn,
    RaikoMobileInputOutlined,
    RaikoNumberInputOutlined,
    RaikoPagination,
    RaikoSectionContainer,
    RaikoSimpleInputOutlined,
    RaikoTableSearchContainer,
    RaikoTableTitleContainer,
    showServerErrorMessage
} from "@moeindal/base-raiko-panel-components";

import {useEffect, useState} from "react";
import {useDebounce} from "@uidotdev/usehooks";
import {css} from "@emotion/css";
import {GameTeamMemberService} from "../../../serverService/gameService/GameTeamMemberService";
import {LoadingHelper} from "../../../util/LoadingHelper";
import {useLoadingDispatcher} from "../../../context/LoadingContext";

export default function SelectPlayerFromList({gameTeamId, selectedPlayer}) {

    let page = 0
    const size = 12


    const service = new GameTeamMemberService()

    const loading = new LoadingHelper(useLoadingDispatcher())

    const [numberOfItems, setNumberOfItems] = useState(0);
    const [pageCount, setPageCount] = useState(0);
    const [playerListData, setPlayerListData] = useState([])

    const [displayName, setDisplayName] = useState("");
    const _displayNameFilter = useDebounce(displayName, 500);

    const [phoneNumber, setPhoneNumber] = useState("");
    const _phoneNumberFilter = useDebounce(phoneNumber, 500);

    const [nationalCode, setNationalCode] = useState("");
    const _nationalCodeFilter = useDebounce(nationalCode, 500);

    useEffect(() => {
        if (typeof service !== 'undefined') {
            getPlayerListDataFromServer()
        }
    }, [_displayNameFilter, _phoneNumberFilter, _nationalCodeFilter]);

    function createPlayerTableRow(id, number, displayName, nationalCode, gender, birthdate, phoneNumber) {
        return {
            id,
            number,
            displayName,
            nationalCode,
            gender: gender && gender.length > 0 && gender === "MALE" ? "مرد" : "زن",
            birthdate: convertUniversalDateTimeToPersianDateTime(birthdate),
            phoneNumber
        }
    }

    function getPlayerListDataFromServer() {
        loading.show()
        service.getPlayerList(gameTeamId, page, size, _displayNameFilter, _phoneNumberFilter, _nationalCodeFilter)
            .then(response => {
                setPageCount(response.totalPage)
                setNumberOfItems(response.numberOfItems)
                setPlayerListData([])

                response.data.map((item, index) => {
                    setPlayerListData(prevState => [
                        ...prevState,
                        createPlayerTableRow(
                            item.id,
                            (page * size) + index + 1,
                            item.displayName,
                            item.nationalCode,
                            item.gender,
                            item.birthdate,
                            item.phoneNumber
                        )

                    ])
                })
            }).catch(reason => {
            showServerErrorMessage(reason)
        }).finally(_ => {
            loading.hide()
        })
    }

    function handlePagination(newPage) {
        page = newPage
        getPlayerListDataFromServer()
        window.scrollTo({top: 0, behavior: "smooth"});
    }

    function handleSelectedPlayer(playerId) {
        if (selectedPlayer) {
            for (let i = 0; i < playerListData.length; i++) {
                if (playerListData[i].id === playerId) {
                    selectedPlayer(playerListData[i]);
                    break;
                }
            }
        }

    }


 return(
     <RaikoGridOneColumn className={css`
            padding: .5rem 1rem 1rem 1rem;
            gap: 2rem;
            width: 100%`}>
         <RaikoSectionContainer
             title={"جستجو"}
             subTitle={"فیلتر های جستجو"}
         >
             <RaikoGridThreeColumn>
                 <RaikoSimpleInputOutlined
                     labelText={"نام کاربری"}
                     value={displayName}
                     setValue={setDisplayName}/>
                 <RaikoMobileInputOutlined
                     labelText={"شماره همراه"}
                     value={phoneNumber}
                     setValue={setPhoneNumber}/>
                 <RaikoNumberInputOutlined
                     labelText={"کد ملی"}
                     value={nationalCode}
                     setValue={setNationalCode}
                     maxLength={10}/>
             </RaikoGridThreeColumn>
         </RaikoSectionContainer>

         <RaikoTableTitleContainer
             title={"بازیکنان"}
             amount={numberOfItems}
             subTitle={"لطفا بازیکن مورد نظر را انتخاب نمایید"}/>
         <RaikoGridThreeColumn>
             {
                 playerListData.map((item, index) => {
                     return <RaikoCardInfoTypeOne
                         key={index}
                         title={item.displayName}
                         titleLabel={item.phoneNumber}
                         iconClass={"ic-profile"}
                         items={[
                             RaikoCardInfoTypeOneItemGenerator("کد ملی", item.nationalCode),
                             RaikoCardInfoTypeOneItemGenerator("جنسیت", item.gender),
                             RaikoCardInfoTypeOneItemGenerator("تاریخ تولد", item.birthdate),
                         ]}
                         onClick={_=>{
                             handleSelectedPlayer(item.id)
                         }}
                     />
                 })
             }
         </RaikoGridThreeColumn>
         <RaikoPagination pageCount={pageCount} handlePaginationChange={handlePagination}/>
     </RaikoGridOneColumn>
 )
}